import { render, staticRenderFns } from "./MessageEdit.vue?vue&type=template&id=4dbd7600&scoped=true&"
import script from "./MessageEdit.vue?vue&type=script&lang=js&"
export * from "./MessageEdit.vue?vue&type=script&lang=js&"
import style0 from "./MessageEdit.vue?vue&type=style&index=0&id=4dbd7600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd7600",
  null
  
)

export default component.exports